"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadata = void 0;
var joi_1 = __importDefault(require("joi"));
exports.metadata = joi_1.default.object({
    description: joi_1.default.string()
        .min(0)
        .max(150)
        .optional()
        .allow(''),
    documentType: joi_1.default.number()
        .min(0)
        .integer()
        .max(99)
        .optional()
        .allow(''),
    fileName: joi_1.default.string()
        .min(0)
        .max(100)
        .required(),
    fileSize: joi_1.default.number()
        .min(0)
        .integer()
        .max(2147483648)
        .required(),
    status: joi_1.default.number()
        .min(0)
        .integer()
        .max(99)
        .optional()
        .allow(''),
});
exports.default = { metadata: exports.metadata };
